<!--
 * @Author: chenxing
 * @Date: 2021-03-12 14:17:37
 * @LastEditors: Yran
 * @LastEditTime: 2021-11-30 14:40:29
-->
<template>
  <a-layout-sider class="layout_side_wrapper" v-model:collapsed="collapsed" :trigger="null" collapsible style="width: 190px; background: #fff; position: relative">
    <a-menu class="left_menu" @openChange="onOpenChange" v-model:selectedKeys="selectedKeys" v-model:openKeys="openKeys" mode="inline" :collapsed="collapsed">
      <template v-for="item in routes" :key="resolvePath(item)">
        <template v-if="!item.hidden">
          <template v-if="!item.children || (item.meta && item.meta.onlyOneChild)">
            <a-menu-item :key="resolvePath(item)" :data-key="resolvePath(item)">
              <app-link :to="resolvePath(item)">
                <svg-icon :icon-class="resolveIconSrc(item)" class-name="menu_icon"></svg-icon>
                <span>{{ item.meta.onlyOneChild ? item.children[0].meta.title : item.meta.title }}</span>
              </app-link>
            </a-menu-item>
          </template>
          <template v-else>
            <a-sub-menu :key="item.key">
              <template #title>
                <span>
                  <svg-icon :icon-class="resolveIconSrc(item)" class-name="menu_icon"></svg-icon>
                  <span>{{ item.meta.title }}</span>
                </span>
              </template>
              <template v-for="subItem in item.children" :key="subItem.path">
                <template v-if="!item.hidden">
                  <template v-if="!subItem.children">
                    <a-menu-item :key="resolvePath(subItem)">
                      <app-link :to="resolvePath(subItem)">
                        <span>{{ subItem.meta.title }}</span>
                      </app-link>
                    </a-menu-item>
                  </template>
                  <template v-else>
                    <a-sub-menu :key="subItem.key">
                      <template #title>
                        <span>
                          <svg-icon :icon-class="resolveIconSrc(subItem)" class-name="menu_icon"></svg-icon>
                          <span>{{ subItem.meta.title }}</span>
                        </span>
                      </template>
                      <template v-for="subItemChild in subItem.children">
                        <a-menu-item v-if="!subItemChild.hidden" :key="resolvePath(subItemChild)">
                          <app-link :to="resolvePath(subItemChild)">
                            <span>{{ subItemChild.meta.title }}</span>
                          </app-link>
                        </a-menu-item>
                      </template>
                    </a-sub-menu>
                  </template>
                </template>
              </template>
            </a-sub-menu>
          </template>
        </template>
      </template>
    </a-menu>
    <div style="position: relative">
      <a v-show="!collapsed" href="https://support.qq.com/product/350349" id="feedback" title="意见反馈">
        <FormOutlined />
      </a>
      <MenuUnfoldOutlined v-if="collapsed" class="menu_fold_icon" @click="collapsed = !collapsed" />
      <MenuFoldOutlined v-else class="menu_fold_icon" @click="collapsed = !collapsed" />
    </div>
  </a-layout-sider>
</template>
<script>
import AppLink from './link';
import defaultSettings from '@/config/defaultSettings';
import { MenuUnfoldOutlined, MenuFoldOutlined, FormOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    AppLink,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    FormOutlined,
  },
  data() {
    return {
      sysName: defaultSettings.sysName,
      sysNameEN: defaultSettings.sysNameEN,
      selectedKeys: [this.$route.path],
      openKeys: [this.$route.meta.upMenuKey],
      collapsed: false,
      activeIcon: [],
    };
  },
  watch: {
    '$route.path': {
      handler(currentPath) {
        this.selectedKeys = [currentPath];
        // 递归获取当前tag对应页面的所有父级目录
        function getParentId(list, path) {
          for (let i in list) {
            if (list[i].path == path) {
              return [list[i].key];
            }
            if (list[i].children) {
              let node = getParentId(list[i].children, path);
              if (node !== undefined) {
                return node.concat(list[i].key);
              }
            }
          }
        }
        this.openKeys = getParentId(this.routes, currentPath);
        this.activeIcon = this.openKeys || [];

        const ele = document.querySelector('.ant-menu-item-selected');
        if (ele && ele.querySelector('.router-link-active')) {
          ele.classList?.remove('ant-menu-item-selected');
        }
      },
      immediate: true,
    },
  },
  computed: {
    routes() {
      return this.$store.state.route.menuRoutes;
    },
    rootMenuList() {
      return this.$store.state.route.menuRoutes.map(item => item.key);
    },
  },
  created() {
    if (this.$route.matched && this.$route.matched.length === 3 && this.$route.matched[1].meta && this.$route.matched[1].meta.upMenuKey) {
      this.openKeys.unshift(this.$route.matched[1].meta.upMenuKey);
    }
  },
  methods: {
    resolveIconSrc(item) {
      if (this.activeIcon?.includes(item.key)) {
        return item.meta.icon + '_active';
      } else {
        return item.meta.icon;
      }
    },
    resolvePath(item) {
      if (item.meta && item.meta.onlyOneChild) return item.children[0].path;
      return item.path;
    },
    // 打开不同的目录时（ 每个根目录一定要有key！！！！）
    // 点击没有子目录的项不会触发此函数
    onOpenChange(openKeys) {
      if (openKeys.length < 2) {
        return;
      }
      const latestOpenKey = openKeys.slice(-2)[0]; //上一个打开的
      const currentOpenKey = openKeys.slice(-1)[0]; //本次打开的
      let latestIndex = this.openKeys.indexOf(latestOpenKey);
      let latestIsRoot = this.rootMenuList.indexOf(latestOpenKey) != -1; //上一个打开的是否是根目录
      let currentIsRoot = this.rootMenuList.indexOf(currentOpenKey) != -1; //本次打开的是否是根目录
      if (currentIsRoot) {
        //如果本次打开的是根目录则关闭上一次打开的
        this.openKeys.splice(latestIndex, 1);
        if (latestOpenKey && !latestIsRoot) {
          //如果本次打开的是根目录，而上次打开的不是根目录，则关闭上一次打开目录的父目录
          const latestOpenParentKey = openKeys.slice(-2)[0];
          let latestParentIndex = this.openKeys.indexOf(latestOpenParentKey);
          this.openKeys.splice(latestParentIndex, 1);
        }
      } else if (!latestIsRoot) {
        //如果本次与上次打开的都不是不是根目录，则关闭上一次打开的目录
        this.openKeys.splice(latestIndex, 1);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.layout_side_wrapper {
  width: 190px !important;
  min-width: 80px !important;
  flex-basis: 185px !important;
  :deep(.ant-layout-sider-children) {
    position: fixed;
  }
  &.ant-layout-sider-collapsed {
    min-width: 30px !important;
    max-width: 35px !important;
    .anticon-menu-unfold {
      transform: translateX(-20px);
    }
  }

  .ant-menu {
    width: 195px;
    height: calc(100% - 30px);
    margin-left: -10px;
    border-right: 0;
    padding-top: 58px;
  }
  .ant-menu-inline-collapsed {
    margin-left: 0 !important;
    .menu_icon + span {
      display: none;
    }
    .menu_icon {
      margin-left: -5px !important;
    }
    width: 35px;
    .ant-menu-submenu-title,
    .ant-menu-item {
      padding: 0 !important;
      text-align: center !important;
    }
  }
  .anticon-menu-unfold {
    text-indent: 28px;
  }
}
.logo {
  height: 48px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  line-height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #2f70f4;
  &.logo-collapsed {
    background-color: #fff;
  }
  img {
    height: 48px;
    width: 100%;
    object-fit: scale-down;
    vertical-align: top;
  }

  .img-collapsed {
    height: 48px;
    width: 44px;
  }
}
// 菜单折叠按钮
.menu_fold_icon {
  font-size: 18px;
  cursor: pointer;
  text-indent: 140px;
}
:deep(.ant-menu-item-selected) {
  background: #2f70f4 !important;
  .router-link-active {
    color: #fff;
  }
}
#feedback {
  width: 48px;
  height: 48px;
  background: #007eff;
  border-radius: 50%;
  position: absolute;
  left: 1em;
  margin: auto;
  bottom: 40px;
  line-height: 48px;
  text-align: center;
  font-size: 18px;
  color: white;
}
</style>
<style lang="less">
.layout_side_wrapper {
  .ant-menu-inline-collapsed {
    margin-left: 0 !important;
    .menu_icon + span {
      display: none;
    }
    .menu_icon {
      margin-left: -5px !important;
    }
    width: 35px;
    .ant-menu-submenu-title,
    .ant-menu-item {
      padding: 0 !important;
      text-align: center !important;
    }
  }
}

@blue: #2f70db;
.iconHover {
  .menu_icon {
    filter: drop-shadow(104px 0 0 @blue);
    transform: translateX(-100px);
  }
}
.left_menu {
  .menu_icon {
    width: 0.5rem;
    vertical-align: text-top;
    margin-right: 0.2rem;
    transform: translate(4px);
  }

  .ant-menu-item {
    margin: 0 !important;
    &:hover {
      background: rgba(239, 243, 247, 1);
    }
  }
  // 有子目录的菜单项
  & > .ant-menu-submenu:not(.ant-menu-item-selected) {
    .ant-menu-submenu-title:hover {
      .iconHover();
    }
  }
  //没有子目录的一级菜单项
  .ant-menu-item:not(.ant-menu-item-selected) {
    &:hover {
      .iconHover();
    }
  }
}
// 悬浮在展开的子项时，父目录样式
.ant-menu-submenu-open:not(.ant-menu-submenu-selected):hover {
  & > .ant-menu-submenu-title {
    .iconHover();
  }
}

// 以下是左侧菜单向左折叠时hover出来的svg样式
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner a {
  color: rgba(0, 0, 0, 0.85) !important;
}
.ant-menu-submenu-title {
  svg {
    margin-right: 10px;
    transform: translate(4px);
    vertical-align: text-bottom;
  }
}
.ant-menu-inline-collapsed-tooltip {
  .ant-tooltip-inner {
    background-color: white;
    svg {
      margin-right: 10px;
      transform: translate(4px);
      vertical-align: text-top;
    }
  }
}
// 左侧菜单收起时悬浮弹出框的左侧小黑箭头
.ant-tooltip-content .ant-tooltip-arrow {
  display: none;
}
</style>